/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DateTimeCriteriaRangeInput
 */
export interface DateTimeCriteriaRangeInput {
    /**
     * 
     * @type {boolean}
     * @memberof DateTimeCriteriaRangeInput
     */
    exclude?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof DateTimeCriteriaRangeInput
     */
    from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof DateTimeCriteriaRangeInput
     */
    to?: Date;
}

export function DateTimeCriteriaRangeInputFromJSON(json: any): DateTimeCriteriaRangeInput {
    return DateTimeCriteriaRangeInputFromJSONTyped(json, false);
}

export function DateTimeCriteriaRangeInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateTimeCriteriaRangeInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'from': !exists(json, 'from') ? undefined : (new Date(json['from'])),
        'to': !exists(json, 'to') ? undefined : (new Date(json['to'])),
    };
}

export function DateTimeCriteriaRangeInputToJSON(value?: DateTimeCriteriaRangeInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'from': value.from === undefined ? undefined : (value.from.toISOString()),
        'to': value.to === undefined ? undefined : (value.to.toISOString()),
    };
}


